import { Icon } from "@garantidos/components"

import { Text } from "@mobi/ds"

import "./style.scss"

const AmortizationCard = ({ labelAmortization, handleOpenInfo }) => (
  <div className="amortizationCard">
    <Icon
      icon="home"
      className="amortizationCard__icon"
      alt="Ícone de uma residência"
      aria-hidden
    />
    <div className="amortizationCard__textWrapper">
      <Text as="p" className="amortizationCard__title">
        sistema de amortização
      </Text>
      <Text as="p" className="amortizationCard__text">
        {labelAmortization}
        <button
          type="button"
          onClick={() => handleOpenInfo("amortization")}
          className="amortizationCard__button amortizationCard__button--lifted"
          aria-label="mais informações sobre o sistema de amortização"
        >
          <Icon
            icon="informação"
            className="amortizationCard__buttonIcon"
            alt="Ícone de informação"
            aria-hidden
          />
        </button>
      </Text>
    </div>
  </div>
)

export default AmortizationCard
